import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconDoor"><Path fillRule="evenodd" clipRule="evenodd" d="M20 21V4.5C20 3.11929 18.8807 2 17.5 2H6.5C5.11929 2 4 3.11929 4 4.5V21H2.5C2.22386 21 2 21.2239 2 21.5C2 21.7761 2.22386 22 2.5 22H21.5C21.7761 22 22 21.7761 22 21.5C22 21.2239 21.7761 21 21.5 21H20ZM7 12.5C7 12.2239 7.22386 12 7.5 12H8.5C8.77614 12 9 12.2239 9 12.5C9 12.7761 8.77614 13 8.5 13H7.5C7.22386 13 7 12.7761 7 12.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoor;
